export const PearlsIcon = () => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 30 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>PearlsIcon</title>
    <g
      id="PearlsIcon"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M15,6 C10.6598687,6.18319736 7.18319736,9.6598687 7,14 C7.01631891,16.1209758 7.83440492,18.1572597 9.29,19.7 C10.3027675,20.5072512 10.9244951,21.7070764 11,23 C11,23.5522847 11.4477153,24 12,24 L18,24 C18.5522847,24 19,23.5522847 19,23 C19.0634597,21.7139754 19.6796136,20.5181264 20.69,19.72 C22.2063149,18.2071321 23.0404824,16.1415744 23,14 C23.0016777,11.8080325 22.1224808,9.70732832 20.56,8.17 C19.075654,6.72566711 17.0702975,5.94300098 15,6 Z M19.34,18.28 C18.2070777,19.2437385 17.4175278,20.5491277 17.09,22 L12.91,22 C12.5854478,20.5625964 11.8155541,19.2642757 10.71,18.29 C9.6267658,17.1221401 9.01716701,15.5927958 9,14 C9.1467298,10.7490077 11.7490077,8.1467298 15,8 C16.5374457,7.94668335 18.0297465,8.52481441 19.13,9.6 C20.3202773,10.7551004 20.9944505,12.3413903 21,14 C21.0357301,15.5959867 20.426468,17.13897 19.31,18.28 L19.34,18.28 Z"
        id="Shape"
        fill="#07616B"
        fillRule="nonzero"
      ></path>
      <path
        d="M18,25 L12,25 C11.4477153,25 11,25.4477153 11,26 C11,26.5522847 11.4477153,27 12,27 L18,27 C18.5522847,27 19,26.5522847 19,26 C19,25.4477153 18.5522847,25 18,25 Z"
        id="Path"
        fill="#07616B"
        fillRule="nonzero"
      ></path>
      <path
        d="M17,28 L13,28 C12.4477153,28 12,28.4477153 12,29 C12,29.5522847 12.4477153,30 13,30 L17,30 C17.5522847,30 18,29.5522847 18,29 C18,28.4477153 17.5522847,28 17,28 Z"
        id="Path"
        fill="#07616B"
        fillRule="nonzero"
      ></path>
      <path
        d="M15,4 C15.5522847,4 16,3.55228475 16,3 L16,1 C16,0.44771525 15.5522847,0 15,0 C14.4477153,0 14,0.44771525 14,1 L14,3 C14,3.55228475 14.4477153,4 15,4 Z"
        id="Path"
        fill="#07616B"
        fillRule="nonzero"
      ></path>
      <path
        d="M4,13 L2,13 C1.44771525,13 1,13.4477153 1,14 C1,14.5522847 1.44771525,15 2,15 L4,15 C4.55228475,15 5,14.5522847 5,14 C5,13.4477153 4.55228475,13 4,13 Z"
        id="Path"
        fill="#07616B"
        fillRule="nonzero"
      ></path>
      <path
        d="M28,13 L26,13 C25.4477153,13 25,13.4477153 25,14 C25,14.5522847 25.4477153,15 26,15 L28,15 C28.5522847,15 29,14.5522847 29,14 C29,13.4477153 28.5522847,13 28,13 Z"
        id="Path"
        fill="#07616B"
        fillRule="nonzero"
      ></path>
      <path
        d="M24.9,4.1 C24.5099625,3.71227641 23.8800375,3.71227641 23.49,4.1 L22.07,5.51 C21.8806873,5.6977666 21.7742017,5.95336246 21.7742017,6.22 C21.7742017,6.48663754 21.8806873,6.7422334 22.07,6.93 C22.2587188,7.11718651 22.514197,7.22153676 22.78,7.22003312 C23.045803,7.22153676 23.3012812,7.11718651 23.49,6.93 L24.9,5.51 C25.2877236,5.11996255 25.2877236,4.49003745 24.9,4.1 L24.9,4.1 Z"
        id="Path"
        fill="#07616B"
        fillRule="nonzero"
      ></path>
      <path
        d="M7.93,6.93 C8.11931265,6.7422334 8.22579832,6.48663754 8.22579832,6.22 C8.22579832,5.95336246 8.11931265,5.6977666 7.93,5.51 L6.51,4.1 C6.11323972,3.7602232 5.52180583,3.78306773 5.15243678,4.15243678 C4.78306773,4.52180583 4.7602232,5.11323972 5.1,5.51 L6.51,6.93 C6.69871883,7.11718651 6.95419702,7.22153676 7.22,7.22003312 C7.48580298,7.22153676 7.74128117,7.11718651 7.93,6.93 Z"
        id="Path"
        fill="#07616B"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
